import AXIOS from "axios"

export const ProcessRequest = (options) => AXIOS(options)
